module.exports = __webpack_public_path__ + "img/main-og.b0135fa1.png";